import React, { useEffect } from "react";
import "../Css/Service.css";
// import Aos from "aos";
import service1 from "../Components/image/service1.png";
import Footer from "../Components/Footer";
import Simpleform from "../Components/Simpleform";
// import sercard1 from "../Components/image/social-network-2187996_640.jpg";
import sercard2 from "../Components/image/monitor-1307227_640.jpg";
import sercard3 from "../Components/image/internet-4463031_640.jpg";
import sercard4 from "../Components/image/twitter-3157979_640.jpg";
import sercard5 from "../Components/image/technology-6701404_640.jpg";
import ProgressBar from "react-bootstrap/ProgressBar";
import sercard6 from "../Components/image/falling-7372662_640.jpg";
import landmark from "../Components/image/shortlogo.png";
import logo2 from "../Components/image/logo2.png";
import { motion, useScroll } from "framer-motion";
import jat from "../Components/image/jat.png.png";
import comroom from "../Components/image/comroom.jpg";
import Aos from "aos"; //animation library file imported
import "aos/dist/aos.css"; // animation css file imported

function Service() {
  useEffect(() => {
    document.title = "Service"; //web title set sevice page
  });
  useEffect(() => {
    // animation hook
    Aos.init({ duration: 1000 });
  }, []);
  const { scrollYProgress } = useScroll(); //top animation set framer motion library imported predefined animation temperaru scroll down and progress right shifted 10 percent.

  return (
    <div id="servicemain">
      <motion.div
        style={{
          scaleX: scrollYProgress,
          position: "fixed",
          top: 0,
          right: 0,
          left: 0,
          height: 4,
          transformOrigin: "0%",
          background: "blue",
        }}
      />
      <div className="container-fluid">
        <div className="row" id="dirrow">
          <div className="col-xl-5" id="director">
            <h6>Hi, I’m</h6>
            <h1 id="largedirtext">Montu kharb</h1>
            <h6 style={{ color: "var(--body-color)", fontSize: "1.5rem" }}>
              Art Director
            </h6>
            <p id="smalldirtext">Date of Birth : Jan 01 2003</p>
            <p id="smalldirtext">Address: XPHV+VHF, Giwana, Haryana 131409</p>
            <p id="smalldirtext">Email : montukharb868@gmail.com</p>
            <p id="smalldirtext">Phone : +91-805-920-2360</p>
          </div>

          <div className="col-xl-5" id="director2">
            <img className="shadow" src={service1} alt="modelpic" />
          </div>
        </div>
      </div>
      <div className="container-fluid ">
        <div
          className="row "
          id="looktext"
          // initial={{ x: 1300 }}
          // animate={{ x: 0, delay: 0.5, scale: [4, 1.1, 1] }}
          // transition={{ transition: 3.3, type: "spring", stiffness: 700 }}
        >
          Have a Look at my Services
        </div>
      </div>
      <div className="container-fluid">
        <div className="row" id="looktext2">
          At our web development company, we specialize in creating custom
          websites tailored to your specific needs. Our team of experienced
          developers uses the latest technologies and industry best practices to
          deliver high-quality web solutions. Whether you need a simple brochure
          website or a complex e-commerce platform, we have the expertise to
          bring your vision to life. We work closely with you throughout the
          development process to ensure that the final product meets your
          expectations and goals. Our websites are not only visually stunning
          but also optimized for search engines and user experience. We offer
          flexible pricing options to fit any budget, and our pricing is always
          transparent with no hidden fees. Our post-launch support and
          maintenance services ensure that your website stays up-to-date and
          secure. We have a proven track record of delivering successful web
          projects for clients across a wide range of industries. We are
          dedicated to providing exceptional customer service and communication
          throughout the entire development process. Contact us today to learn
          how we can help take your online presence to the next level.
        </div>
      </div>
      <div className="container-fluid">
        <div className="row" id="servicerow1">
          <div
            className="col-md-3"
            id="sercard1"
            whileHover={{ scale: 1.03, Y: -12 }}
          >
            <img id="serimage" src={sercard2} alt="card" />
            <h6 id="sercardname">Web Design</h6>
          </div>
          <div
            className="col-md-3"
            id="sercard3"
            whileHover={{ scale: 1.03, Y: -12 }}
          >
            <img id="serimage" src={sercard3} alt="card" />
            <h6 id="sercardname">Social Media</h6>
          </div>
          <div
            className="col-md-3"
            id="sercard4"
            whileHover={{ scale: 1.03, Y: -12 }}
            data-aos-anchor-placement="bottom-bottom"
          >
            <img id="serimage" src={sercard4} alt="card" />
            <h6 id="sercardname">Web application</h6>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row" id="servicerow1">
          <div
            // data-aos="fade-up"
            data-aos-anchor-placement="bottom-bottom"
            className="col-md-3"
            id="sercard5"
            whileHover={{ scale: 1.03, Y: -12 }}
          >
            <img id="serimage" src={sercard5} alt="card" />
            <h6 id="sercardname">Data Analyst</h6>
          </div>
          <div
            data-aos-anchor-placement="bottom-bottom"
            className="col-md-3"
            id="sercard6"
            whileHover={{ scale: 1.03, Y: -12 }}
          >
            <img id="serimage" src={sercard6} alt="card" />
            <h6 id="sercardname">Mobile Devlopent</h6>
          </div>
        </div>
      </div>

      <div className="container0-fluid " id="myquatext">
        <div
          className="row"
          id="oualirow"
          whileHover={{ scale: 1.03, Y: -12 }}
          data-aos="zoom-in"
        >
          <p id="sermyouali">My Qualifications</p>
        </div>
        <div
          className="row text-center"
          style={{ width: "98vw", paddingLeft: "2rem" }}
        >
          <p
            style={{
              color: "var(--body-color)",
              background: "var(--service-bg-color)",
              wordBreak: "break-all",
              fontSize: "16px",
            }}
          >
            Who are in extremely love with eco friendly system.
          </p>
        </div>
      </div>
      <div className="container-fluid" style={{ width: "70vw" }} id="rangeid">
        <div className="row " style={{ width: "70vw" }} data-aos="zoom-in">
          <h4 id="pgrangetext" data-aos="zoom-in">
            Html
          </h4>
          <div id="prog30">
            <ProgressBar variant="success" now={100} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            Css
          </h4>
          <div id="prog30">
            <ProgressBar variant="info" now={95} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            Bootstrap
          </h4>
          <div id="prog30">
            <ProgressBar variant="danger" now={85} data-aos="zoom-in" />
          </div>

          <h4 id="pgrangetext" data-aos="zoom-in">
            React
          </h4>
          <div id="prog30">
            <ProgressBar variant="danger" now={100} data-aos="zoom-in" />
          </div>

          <h4 id="pgrangetext" data-aos="zoom-in">
            MongoDb
          </h4>
          <div id="prog30">
            <ProgressBar variant="warning" now={95} data-aos="zoom-in" />
          </div>

          <h4 id="pgrangetext" data-aos="zoom-in">
            c
          </h4>
          <div id="prog30">
            <ProgressBar variant="success" now={100} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            c++
          </h4>
          <div id="prog30">
            <ProgressBar variant="success" now={100} data-aos="zoom-in" />
          </div>

          <h4 id="pgrangetext" data-aos="zoom-in">
            Java
          </h4>
          <div id="prog30">
            <ProgressBar variant="info" now={15} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            Java Script
          </h4>
          <div id="prog30">
            <ProgressBar variant="warning" now={98} data-aos="zoom-in" />
          </div>

          <h4 id="pgrangetext" data-aos="zoom-in">
            Python
          </h4>
          <div id="prog30">
            <ProgressBar variant="warning" now={65} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            Node js
          </h4>
          <div id="prog30">
            <ProgressBar variant="sucess" now={90} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            XML
          </h4>
          <div id="prog30">
            <ProgressBar variant="warning" now={100} data-aos="zoom-in" />
          </div>
          <h4 id="pgrangetext" data-aos="zoom-in">
            Formik &Yup
          </h4>
          <div id="prog30">
            <ProgressBar variant="warning" now={85} data-aos="zoom-in" />
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div
          className="row"
          style={{
            background: "var(--team2023-background-color)",
            marginTop: "2rem",
          }}
        >
          <h1 id="team2023" data-aos="zoom-in">
            CEO
          </h1>
        </div>
      </div>
      <div className="container-fluid">
        {/* <div className="container"> */}
        <div className="row servicelastrow">
          <div className="col-md-3"id="logo">
            <img src={logo2} alt="logo"/>
          </div>
          <div className="col-md-3" id="jat">
            <img src={jat} alt="ceo"/>
          </div>
          <div className="col-md-3"id="logo2">
            <img src={landmark} alt="landmark"/>
          </div>
        </div>
        {/* </div> */}
      </div>
      <div className="container-fluid">
        <div className="row servicelastrow">
          <div className="col-xl-5">

          <Simpleform/>
          </div>
          <div className="col-md-5" id="logo3">
            <img src={comroom} alt="laptop"/>
          </div>
        </div>
      </div>
      <div className="container-fluid">
        <div className="row" style={{ background: "rgb(7,10,79)" }}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
export default Service;
